var AdvOC = require('../../src/js/client/AdvancedOptsContext.js');

exports.advancedOptsContext = AdvOC.AdvancedOptsContext;

exports.initialAdvancedOpts = AdvOC.initialAdvancedOpts;
